export class UserLimit {
  user_id?: string | undefined = '';
  currency_id?: string | undefined = '';
  currency?: string | undefined = '';
  daily_withdraw_price: number | null = null;
  monthly_withdraw_price: number | null = null;
  loading: boolean = false;
}
